/**
 * Google Analytics 4 helpers.
 *
 * The gtag loader and base config (with send_page_view: false) live in
 * public/index.html so they load once for the whole SPA. Because this is a
 * single-page app, page views don't fire automatically on navigation — they
 * are sent manually via trackPageView() on each route change.
 */

export const GA_MEASUREMENT_ID = 'G-YEZXD584L5';

/** True once the gtag script has loaded on the page. */
const gtagReady = () =>
  typeof window !== 'undefined' && typeof window.gtag === 'function';

/**
 * Send a GA4 event.
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackEvent(eventName, params = {}) {
  if (gtagReady()) {
    window.gtag('event', eventName, params);
  }
}

/**
 * Send a GA4 page_view. Called on every route change.
 * @param {string} path  - location pathname (+ search)
 * @param {string} [title] - defaults to the current document title
 */
export function trackPageView(path, title) {
  if (gtagReady()) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href,
    });
  }
}
